import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Card,
    CardContent,
    CardActions,
    Button,
    Stack,
    CircularProgress,
} from '@mui/material';
import {
    Close as CloseIcon,
    SportsEsports as SportsEsportsIcon,
    Public as PublicIcon,
} from '@mui/icons-material';

const GameModeModal = ({ open, onClose, onSelectOffline, onSelectOnline, adCheckPending = false }) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: { borderRadius: 3 }
            }}
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
                <Typography variant="h6" fontWeight="bold">
                    {t('mode_selector.title')}
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pb: 3 }}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Card
                        elevation={2}
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            borderRadius: 2,
                            border: '2px solid transparent',
                            '&:hover': { borderColor: '#667eea' },
                        }}
                    >
                        <CardContent sx={{ flexGrow: 1, textAlign: 'center', py: 3 }}>
                            <SportsEsportsIcon sx={{ fontSize: 56, color: '#667eea', mb: 1 }} />
                            <Typography variant="h6" fontWeight="bold" gutterBottom>
                                {t('mode_selector.offline_title')}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {t('mode_selector.offline_description')}
                            </Typography>
                        </CardContent>
                        <CardActions sx={{ p: 2, pt: 0 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={onSelectOffline}
                                disabled={adCheckPending}
                                startIcon={adCheckPending ? <CircularProgress size={18} color="inherit" /> : null}
                                sx={{
                                    py: 1,
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
                                    }
                                }}
                            >
                                {t('mode_selector.offline_button')}
                            </Button>
                        </CardActions>
                    </Card>

                    <Card
                        elevation={2}
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            borderRadius: 2,
                            border: '2px solid transparent',
                            '&:hover': { borderColor: '#667eea' },
                        }}
                    >
                        <CardContent sx={{ flexGrow: 1, textAlign: 'center', py: 3 }}>
                            <PublicIcon sx={{ fontSize: 56, color: '#667eea', mb: 1 }} />
                            <Typography variant="h6" fontWeight="bold" gutterBottom>
                                {t('mode_selector.online_title')}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {t('mode_selector.online_description')}
                            </Typography>
                        </CardContent>
                        <CardActions sx={{ p: 2, pt: 0 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={onSelectOnline}
                                disabled={adCheckPending}
                                startIcon={adCheckPending ? <CircularProgress size={18} color="inherit" /> : null}
                                sx={{
                                    py: 1,
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
                                    }
                                }}
                            >
                                {t('mode_selector.online_button')}
                            </Button>
                        </CardActions>
                    </Card>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default GameModeModal;
